import { Component, OnInit } from '@angular/core';
import { GoogleMap, MapMarker } from '@angular/google-maps';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MapService } from '../../Services/map.service';
import { apiEndPoints } from '../../api/apiEndPoint';


@Component({
  selector: 'app-maps',
  standalone: true,
  imports: [GoogleMap],
  templateUrl: './maps.component.html',
  styleUrls: ['./maps.component.css'],
})
export class MapsComponent implements OnInit {
  center: google.maps.LatLngLiteral = { lat: 13.0827, lng: 80.2707 }; // Default center
  zoom = 8;
  map!: google.maps.Map;
  cityPolygons: any[] = [];
  fenceData: any;

  constructor(private mapService: MapService) { }

  ngOnInit() {
    this.getAllFence();
  }

  onMapReady(map: google.maps.Map): void {
    this.map = map;
    map.setOptions({
      minZoom: 3,
      maxZoom: 20, 
    });
  }

  // ---------------------- Get All Fence API ---------------------- //
  getAllFence() {
    this.mapService.getAllFence(apiEndPoints.allFence).subscribe({
      next: (response: any) => {
        if (response.isSuccess) {
          this.fenceData = response.body.details.cityCoordinates;
          this.drawCityFences(response.body.details.cityCoordinates);
        }
      }
    });
  }

  // ---------------------- Generate Random Colors ---------------------- //
  generateRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < this.fenceData.length; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  generateColorFromString(input: string): string {
    let hash = 0;
    for (let i = 0; i < input.length; i++) {
      hash = input.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xFF;
      color += ('00' + value.toString(16)).slice(-2);
    }
    return color;
  }

  // ---------------------- Draw City Fences ---------------------- //
  drawCityFences(cityData: any[]) {
    cityData?.forEach((city, index) => {
      const color = this.generateColorFromString(city.cityName);

      const paths = city.coordinates.map((coord: any) => ({
        lat: coord.latitude,
        lng: coord.longitude
      }));

      const polygon = new google.maps.Polygon({
        paths: paths,
        strokeColor: color,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: color,
        fillOpacity: 0.35,
      });

      polygon.setMap(this.map);
      this.cityPolygons.push(polygon);

      const bounds = new google.maps.LatLngBounds();
      paths.forEach((point: any) => bounds.extend(point));
      const center = bounds.getCenter();

      new google.maps.Marker({
        position: { lat: center.lat(), lng: center.lng() },
        map: this.map,
        label: {
          text: city.cityName,
          fontSize: '14px',
          fontWeight: 'bold',
        }
      });
    });
  }

}
